// extracted by mini-css-extract-plugin
export default {"button":"CarouselButtons_button__+ehQh","prev":"CarouselButtons_prev__7Mf44","next":"CarouselButtons_next__STI-I","dot":"CarouselButtons_dot__ivOVh"};